import React from 'react';
import SortableTableHeader from 'components/pure/sortable-tables/SortableTableHeader';
import './CoachingEffectivenessTableHeader.styl';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export default class CoachingEffectivenessTableHeader extends React.PureComponent {
  render() {
    const {
      data: {label, column, tooltipContent, tooltipClassName},
      onSort,
      sortColumn,
      sortDirection,
    } = this.props;
    return (
      <GenericTooltip
        hoverBehavior
        positionTop
        delay={TOOLTIP_DELAY}
        className={tooltipClassName}
        tooltip={tooltipContent}>
        <SortableTableHeader
          label={label}
          renderColumn={column}
          onClick={() => onSort(column, sortDirection)}
          sortDirection={sortDirection}
          sortColumn={sortColumn}
          tooltipEnabled={false}
        />
      </GenericTooltip>
    );
  }
}
